import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { MenuItem } from "primeng/api/menuitem";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BrowserStorageService } from "src/app/services/storage.service";

@Component({
  selector: "app-user-account",
  templateUrl: "./userAccount.component.html",
  styleUrls: ["./userAccount.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class UserAccountComponent implements OnInit {
  items: MenuItem[] = [];

  constructor(
    private router: Router,
    private translate: TranslateService,
    private browserStorageService: BrowserStorageService
  ) {}

  ngOnInit(): void {
    this.initMenu();
    this.translate.onLangChange.subscribe((lang) => {
      this.initMenu();
    });
  }

  private initMenu() {
    this.translate
      .get([
        "change_email_address",
        "invoices",
        "profit_header",
        "arranger_details",
        "contracts",
        "orders",
        "my_notes",
        "add_note",
        "arranger_panel",
        "prepaid_account",
        "prepaid",
        "my_account",
        "my_details",
        "change_password",
        "my_orders",
        "invoice_details",
        "add_photo",
        "newsletter_user_menu",
        "delete_account",
      ])
      .subscribe((t) => {
        setTimeout(() => {
          this.items = [];

          if (this.browserStorageService.get("_role") == "arranger") {
            this.items.push({
              label: t.arranger_panel,
              items: [
                { label: t.add_note, routerLink: "/my-account/add-note" },
                { label: t.my_notes, routerLink: "/my-account/note-list" },
                { label: t.profit_header, routerLink: "/my-account/profit" },
                { label: t.contracts, routerLink: "/my-account/contracts" },
                {
                  label: t.arranger_details,
                  routerLink: "/my-account/arranger-details",
                },
                { label: t.add_photo, routerLink: "/my-account/add-photo" },
              ],
            });
          }

          this.items.push({
            label: t.my_account,
            items: [
              { label: t.my_orders, routerLink: "/my-account/my-orders" },
              {
                label: t.prepaid_account,
                routerLink: "/my-account/prepaid-account",
              },
              { label: t.my_details, routerLink: "/my-account/my-details" },
              {
                label: t.invoice_details,
                routerLink: "/my-account/invoice-details",
              },
              { label: t.invoices, routerLink: "/my-account/invoices" },
              {
                label: t.change_email_address,
                routerLink: "/my-account/change-email-address",
              },
              {
                label: t.change_password,
                routerLink: "/my-account/change-password",
              },
              {
                label: t.newsletter_user_menu,
                routerLink: "/my-account/newsletter-rezygnacja",
              },
              {
                label: t.delete_account,
                routerLink: "/my-account/delete-account",
              },
            ],
          });
        }, 100);
      });
  }
}
